import React, { useEffect } from 'react';

import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { CheckmarkAnimation, CheckmarkAnimationTypes } from '@eika/checkmark-animation';

import { useBlockEfakturaCreditor } from '../../fetchHooks/useEfaktura';
import type { EFakturaCreditor } from '../../generated-types';
import useTranslation, { format } from '../../hooks/useTranslation';
import CenteredModalContent from '../shared/CenteredModalContent/CenteredModalContent';
import { Content } from '../shared/Content';
import { ErrorCardWrapper } from '../shared/ErrorCardWrapper';

import './BlockEfakturaCreditor.scss';

interface Props {
    creditor: EFakturaCreditor;
    setBlocked: (value: boolean) => void;
}

const BlockEfakturaCreditor: React.FC<Props> = ({ creditor, setBlocked }) => {
    const translated = useTranslation();

    const {
        isSuccess,
        isPending,
        error,
        reset,
        mutate: blockCreditor,
    } = useBlockEfakturaCreditor({ onSuccess: () => setBlocked(true) });

    useEffect(() => {
        reset();
    }, [creditor, reset]);

    if (isSuccess) {
        return (
            <CenteredModalContent withMessage>
                <CheckmarkAnimation checkmarkAnimationType={CheckmarkAnimationTypes.POSITIVE} />
                <h3>{format(translated.eFakturaReservation.blockSuccess, creditor.name)}</h3>
            </CenteredModalContent>
        );
    }

    if (error) {
        return (
            <Content>
                <ErrorCardWrapper exception={error} defaultError={translated.eFakturaReservation.blockError} isModal>
                    <ButtonWithSpinner
                        showSpinner={isPending}
                        buttonType="positive"
                        onClick={() => blockCreditor(creditor.creditorId)}
                    >
                        {translated.tryAgain}
                    </ButtonWithSpinner>
                </ErrorCardWrapper>
            </Content>
        );
    }

    return (
        <div className="block-efaktura-creditor">
            <div>
                <h2>{translated.eFakturaReservation.youChose}</h2>
                <p className="block-efaktura-creditor__name">{creditor.name}</p>
                <p>{format(translated.eFakturaReservation.blockDescription, creditor.name)}</p>
            </div>
            <ButtonWithSpinner
                buttonType="positive"
                onClick={() => blockCreditor(creditor.creditorId)}
                showSpinner={isPending}
            >
                {translated.eFakturaReservation.confirmBlock}
            </ButtonWithSpinner>
        </div>
    );
};

export default BlockEfakturaCreditor;
